import { AuthUser } from "@/requests/gen/react-query/fastAPI.schemas";
import React from "react";

interface AuthContextProps {
  authUser: AuthUser | null;
  setAuthUser: React.Dispatch<React.SetStateAction<AuthUser | null>>;
}

export const AuthContext = React.createContext<AuthContextProps>({
  authUser: null,
  setAuthUser: () => {},
});
